const subdirectoryList = Object.freeze({
    ch: '/ch',
    dech: '/ch-de',
    au: '/au',
    mx: '/mx',
    es: '/es',
    couk: '/uk', // Keys reflect data-domain attribute values specified in the <body> tag
});

const removeTrailingSlash = url => url.replace(/\/$/g, '');

const isPathInSubdirectoryValues = subdirPath =>
    Object.values(subdirectoryList).includes(subdirPath);

const extractSubdirectoryFromPathName = () => {
    if (typeof window === 'undefined' || typeof window.location === 'undefined') {
        return '';
    }

    const subdir = window.location.pathname.split('/')[1];
    const subdirPath = subdir ? `/${subdir}` : '';

    return isPathInSubdirectoryValues(subdirPath) ? subdirPath : '';
};

const getDocumentDomain = () => {
    if (typeof document === 'undefined' || !document.body) {
        return '';
    }

    const { dataset } = document.body;
    return dataset && typeof dataset.domain === 'string' ? dataset.domain : '';
};

const isSubdirectory = domain =>
    Object.prototype.hasOwnProperty.call(subdirectoryList, domain);

const createPathFromDomain = domain => {
    if (domain) {
        if (!isSubdirectory(domain)) {
            return '';
        }

        return removeTrailingSlash(subdirectoryList[domain]);
    }

    const extracted = extractSubdirectoryFromPathName();

    if (!extracted) {
        return '';
    }

    return removeTrailingSlash(extracted);
};

const isRelativeURL = url => typeof url === 'string' && url.startsWith('/');

const getEndpoint = (url = '') => {
    if (!url) {
        return '';
    }

    return isRelativeURL(url)
        ? `${createPathFromDomain(getDocumentDomain())}${url}`
        : url;
};

module.exports = {
    getEndpoint,
};
